<script>
    import MainContainer from '@/components/container/MainContainer.vue';
    import LeftPanel from '@/components/container/LeftPanel.vue';
    import RightContainer from '@/components/container/RightContainer.vue';

    import ButtonAnyNew from '@/components/left-panel/any-button/ButtonAnyNew.vue';
    import ButtonReturn from '@/components/left-panel/unique-buttons/ButtonReturn.vue';

    import TagList from '@/components/page-tag-edit/TagList.vue';

    import TagAdd from '@/components/page-tag-edit/tag-add/TagAdd.vue';
    import TagEdit from '@/components/page-tag-edit/tag-edit/TagEdit.vue';


    export default {
        components: {
            MainContainer: MainContainer,
            LeftPanel: LeftPanel,
            RightContainer: RightContainer,

            ButtonAnyNew: ButtonAnyNew,
            ButtonReturn: ButtonReturn,

            TagList: TagList,

            TagAdd: TagAdd,
            TagEdit: TagEdit,
        },
        async mounted() {
            this.$store.commit('IS_LOAD', true);
            await this.$store.dispatch('CHECK_TAGS');
            this.$store.commit('IS_LOAD', false);
        },
        methods: {
            async toggleNewTag() {
                this.$store.commit('IS_SHOW_TAG_ADD', 
                    !this.$store.getters.IS_SHOW_TAG_ADD
                );
                this.$store.dispatch('CHECK_TAG_ADD');
            }
        }

    }
</script>


<template>
    <TagAdd />
    <TagEdit />

    <MainContainer>
        <LeftPanel>
            <ButtonAnyNew
                title="New Tag"
                :method="toggleNewTag"
            />
            <hr class="left-separator">
            <ButtonReturn />
        </LeftPanel>
        <RightContainer>
            <TagList />
        </RightContainer>
    </MainContainer>
</template>